import { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import { toast } from 'sonner';
import { bc } from '../lib/api';
import { useAuth } from '../lib/auth';

let cache = null;
const listeners = new Set();
const load = () => (cache ? Promise.resolve(cache) : bc.wishlist().then(d => (cache = new Set(d.ids))));

export default function WishlistButton({ cpId, className = '' }) {
  const { user } = useAuth();
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!user) return;
    const sync = () => setOn(!!cache?.has(cpId));
    listeners.add(sync);
    load().then(sync).catch(() => {});
    return () => listeners.delete(sync);
  }, [user, cpId]);

  const toggle = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (!user) return window.dispatchEvent(new CustomEvent('mandispot:open-auth', { detail: { mode: 'signin' } }));
    try {
      await load();
      if (on) { await bc.wishRemove(cpId); cache.delete(cpId); } else { await bc.wishAdd(cpId); cache.add(cpId); toast.success('Saved to wishlist'); }
      listeners.forEach(f => f());
    } catch { toast.error('Could not update wishlist'); }
  };

  return (
    <button data-testid={`wishlist-btn-${cpId}`} onClick={toggle} aria-label={on ? 'Remove from wishlist' : 'Save to wishlist'}
      className={`w-9 h-9 rounded-full bg-white/90 border border-border grid place-items-center hover:scale-110 transition-transform ${className}`}>
      <Heart className={`w-4 h-4 ${on ? 'fill-[#E53935] text-[#E53935]' : 'text-ink/60'}`}/>
    </button>
  );
}
